export default "__VITE_ASSET__CoPZF8Qx__"